// globals window
import i18next from 'i18next';
import Backend from 'i18next-chained-backend';
import i18nextXhrBackend from 'i18next-xhr-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import { reactI18nextModule } from 'react-i18next';
import { en, de } from '@bytebrand/i18n-dictionaries';
import AppStore from './source/stores/AppStore';
import { DEFAULT_LANG } from './source/framework/constants/app';
// eslint-disable-next-line no-magic-numbers
const expires = 360 * 24 * 60 * 60 * 1000;
const i18nBE = [
    i18nextXhrBackend
];
const i18nBEOptions = [{
        loadPath: '/assets/locales/{{lng}}/{{ns}}.json',
        // @ts-ignore
        queryStringParams: { v: window.__BUILD_NUMBER__ }
    }];
if (process.env.NODE_ENV !== 'development') {
    i18nBE.unshift(LocalStorageBackend);
    i18nBEOptions.unshift({
        // prefix for stored languages
        prefix: 'i18next_res_',
        // expiration
        expirationTime: expires,
        // language versions
        versions: {
            // @ts-ignore
            en: window.__BUILD_NUMBER__,
            // @ts-ignore
            de: window.__BUILD_NUMBER__,
            // @ts-ignore
            ru: window.__BUILD_NUMBER__
        }
    });
}
export const i18nextInstance = i18next
    .use(Backend)
    .use(reactI18nextModule)
    // .use(LanguageDetector)
    .init({
    lng: DEFAULT_LANG,
    fallbackLng: 'de',
    // have a common namespace used around the full app
    // 'autobahn' = SRP/VDP redesign copy (lazy-loaded by translate([...]) too; preloaded to avoid raw-key flash)
    ns: ['common', 'CheckoutPage', 'Notifications', 'autobahn'],
    defaultNS: 'common',
    debug: (process.env.NODE_ENV === 'development'),
    interpolation: {
        escapeValue: false // not needed for react!!
    },
    backend: {
        backends: i18nBE,
        backendOptions: i18nBEOptions
    },
    react: {
        wait: true
    }
}, (err, t) => {
    if (err)
        return console.log('Something went wrong loading', err);
    i18next.addResourceBundle('en', 'cbd', en, true, true);
    i18next.addResourceBundle('de', 'cbd', de, true, true);
    return AppStore.changeLang(i18nextInstance.language);
});
